// hero-swiper.js — simple, robust init + mobile hide toggles
(function(){
  function initHero(root){
    if(!root) return;

    // apply heights derived from CSS vars
    function applyHeights(){
      var desk = getComputedStyle(root).getPropertyValue('--desk-h') || '520px';
      var mob  = getComputedStyle(root).getPropertyValue('--mob-h') || '260px';
      var use = (window.innerWidth <= 767) ? mob.trim() : desk.trim();
      // set on root and swiper element
      root.style.height = use;
      var swiperEl = root.querySelector('.swiper');
      if(swiperEl) swiperEl.style.height = use;
      root.querySelectorAll('.swiper-wrapper, .swiper-slide').forEach(function(n){ n.style.height = '100%'; });
    }

    applyHeights();
    window.addEventListener('resize', applyHeights);

    // mobile hide toggle based on section data- attributes
    function applyMobileToggles(){
      var hideTitle = root.getAttribute('data-hide-title-mobile') === 'true';
      var hideSub = root.getAttribute('data-hide-subtitle-mobile') === 'true';
      var hideBtn = root.getAttribute('data-hide-button-mobile') === 'true';

      if(window.innerWidth <= 767){
        hideTitle ? root.classList.add('hide-title-mobile') : root.classList.remove('hide-title-mobile');
        hideSub ? root.classList.add('hide-subtitle-mobile') : root.classList.remove('hide-subtitle-mobile');
        hideBtn ? root.classList.add('hide-button-mobile') : root.classList.remove('hide-button-mobile');
      } else {
        root.classList.remove('hide-title-mobile','hide-subtitle-mobile','hide-button-mobile');
      }
    }
    applyMobileToggles();
    window.addEventListener('resize', applyMobileToggles);

    // init Swiper if available (safe check)
    if(typeof window.Swiper !== 'function') return;

    var loop = root.getAttribute('data-loop') === 'true';
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(root.getAttribute('data-interval')) || 6000;

    var swiper = new window.Swiper(root.querySelector('.swiper'), {
      loop: loop,
      autoplay: autoplay ? { delay: interval, disableOnInteraction: false } : false,
      slidesPerView: 1,
      centeredSlides: true,
      pagination: { el: root.querySelector('.swiper-pagination'), clickable:true },
      navigation: { nextEl: root.querySelector('.swiper-next'), prevEl: root.querySelector('.swiper-prev') },
      watchOverflow: true,
      autoHeight: false
    });

    // update after images load (prevents initial layout gap)
    root.querySelectorAll('img.slide-bg').forEach(function(img){
      if(img.complete) return;
      img.addEventListener('load', function(){ try{ swiper.update(); }catch(e){} });
    });

    // small safety update
    setTimeout(function(){ try{ swiper.update(); }catch(e){} }, 100);
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.hero-swiper').forEach(initHero);
  });

  // Shopify editor support
  document.addEventListener('shopify:section:load', function(e){
    var root = e.target && e.target.querySelector ? e.target.querySelector('.hero-swiper') : null;
    if(root) initHero(root);
  });
})();
